import CategoryCollectionPage from './CategoryCollectionPage';
import { TOREBCE_CONFIG } from './categoryPageConfigs';
export default function KwiatyWTorebcePage() {
  return <CategoryCollectionPage config={TOREBCE_CONFIG} />;
}
